import { makeStyles } from "@material-ui/core/styles";
import {
  DEFAULT_BOX_SHADOW,
  instance1,
  PRIMARY_BACKGROUND,
} from "App/constants";

export const urlGet = "/setting/list";

export const urlUpload = "/#";

export const STATE_FORM_DATA = {
  id: "",
  kode_setting: "",
  kategori_id: null,
  nama_kategori:"Pilih Kategori Setting",
  remark: "",
  setting_data_1: "",
  setting_data_2: "",
  setting_data_3: "",
};

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  kode_setting: "",
  kategori_id: null,
  nama_kategori:"Pilih Kategori Setting",
};

export const getSetting = async (
  formFilter,
  pages,
  limit,
) => {
  try {
    const api = await instance1.post(urlGet, {
      id: formFilter.id,
      kode_setting: formFilter.kode_setting,
      kategori_id: formFilter.kategori_id,
      jumlah: limit,
      halaman: pages,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};


export const STYLE_MENUS = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "kode_setting",
    disablePadding: false,
    label: "KODE SETTING",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN SETTING",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "setting_data_1",
    disablePadding: false,
    label: "SETTING DATA 1",
    align: "left",
    minWidth: "250px",
  },
  {
    id: "setting_data_2",
    disablePadding: false,
    label: "SETTING DATA 2",
    align: "left",
    minWidth: "250px",
  },
  {
    id: "setting_data_3",
    disablePadding: false,
    label: "SETTING DATA 3",
    align: "left",
    minWidth: "250px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED DATE",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

